import { axiosInstance } from "../../Utils/AxiosInstance";
export const GetProjectData = (data) => {
  return {
    type: "get_projectData",
    payload: data,
  };
};
const GetAssignedProjects = (data) => ({
  type: "get_assignedProjects",
  payload: data,
});

export const fetchAssignedProjects = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get("Projects/GetAssigned");
      if (response.data.IsSuccess === true) {
        // Dispatching action with the received data
        dispatch(GetAssignedProjects(response.data.Data));
      } else {
        console.warn("API Error:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching assigned projects:", error);
    }
  };
};
